module.exports = __webpack_public_path__ + "img/wechat.6af0d915.png";